import React from 'react';
import { Box, Flex, Text } from '@skin-seoul/design-system';

interface LoyaltyBannerMobileProps {
  points: number;
  titleLine1?: string;
  titleLine2?: string;
  pointsUnit?: string;
}

export const LoyaltyBannerMobile = ({
  points,
  titleLine1 = 'Your',
  titleLine2 = 'SkinSociety',
  pointsUnit = 'Pts',
}: LoyaltyBannerMobileProps) => {
  return (
    <Box
      position="relative"
      width="100%"
      height="112px"
      borderRadius="12px"
      bgGradient="to-tl"
      gradientFrom="#311275"
      gradientTo="#754DCC"
      overflow="hidden"
    >
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" px={4} zIndex={1}>
        {/* Left Side - Title */}
        <Flex direction="column" gap={0}>
          <Text color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold">
            {titleLine1}
          </Text>
          <Text color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold">
            {titleLine2}
          </Text>
        </Flex>

        {/* Right Side - Points */}
        <Text color="white" textStyle="heading.h3.mobile" fontWeight="bold">
          {points} {pointsUnit}
        </Text>
      </Flex>
    </Box>
  );
};
